import { oc } from '@orpc/contract';
import { searchContactsInputSchema, searchContactsOutputSchema } from '../schemas/contacts.schemas.js';
export const searchContactsContract = oc
    .route({
    method: 'GET',
    path: '/contacts',
    tags: ['Contacts'],
    summary: 'Search contacts by name or phone number',
})
    .input(searchContactsInputSchema)
    .output(searchContactsOutputSchema);
//# sourceMappingURL=search-contacts.contract.js.map